import React from "react";
import { Link } from "react-router-dom";
import { SalesWrap } from "../../api/order/generated/src";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import SalesArticleList from "../salesArticle/salesArticleList";

interface ISalesWrapListItemProps {
    item: SalesWrap;

    noLink?: boolean
}

const SalesWrapListItem = (props:ISalesWrapListItemProps) => {
    const { item } = props;

    const { t } = useTranslation();

    const isComplete = item.quantity != null && item.quantity === item.quantityBooked;
    const isPartial = item.quantity != null && (item.quantityBooked ?? 0) > 0 && item.quantity > (item.quantityBooked ?? 0)

    const renderListItem = () => {
        return (
            <div 
                key={item.id} 
                // className={`bg-white rounded-lg border p-4 ${getStatusColor(isComplete ? "complete" : isPartial ? "partial" : "pending")}`}

                className={classNames(
                    "bg-white rounded-lg border p-4",
                    "hover:border-gray-300 hover:shadow-sm"
                )}

                
            >
                <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-2 mb-1">
                            <h3 className="font-medium text-gray-900">{item.id}</h3>
                            
                            <span className={`px-2 py-1 text-xs rounded-full font-medium ${
                                isComplete ? 'bg-green-100 text-green-700' :
                                    isPartial ? 'bg-blue-100 text-blue-700' :
                                        'bg-gray-100 text-gray-600'
                            }`}>
                                {item.quantityBooked ?? 0}/{item.quantity ?? 0}
                            </span>
                        </div>
                        <p className="text-sm text-gray-600 mb-3">{item.annotation}</p>
                        <p className="text-sm text-gray-600 mb-3">{item.user?.name}</p>
                        <p className="text-sm text-gray-600 mb-3">{item.customer?.name}</p>
                        <p className="text-sm text-gray-600 mb-3">{item.deliveryDate != null && format(item.deliveryDate, "dd.MM.yyyy")}</p>
                        
                        {/* Progress bar for individual item */}
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mb-3">
                            <div 
                                className={`h-1.5 rounded-full transition-all duration-300 ${
                                    isComplete ? 'bg-green-500' :
                                        isPartial ? 'bg-blue-500' :
                                            'bg-gray-300'
                                }`}
                                style={{ width: `${(item.quantity ?? 0) > 0 && Math.min(((item.quantityBooked ?? 0) / (item.quantity ?? 0)) * 100, 100)}%` }}
                            ></div>
                        </div>
                    </div>



                
                </div>

                {/* <Collapse open={showInfos || !collapseInfos}>
                    <div className="w-full">
                        <div className="pt-4">
                            <SalesArticleDetail 
                                // articleId={article.id}
                                article={article}
                            />  
                        </div>
                    </div>
                </Collapse> */}

                
            </div>
        );
    }

    const renderDetailItem = () => {
        return (
            <div className="gap-4 grid w-full  mb-4">
                <div className="flex-1 min-h-0 overflow-y-auto">
                    {/* <SalesOrderList 
                        salesOrders={item.salesOrders ?? []}
                    /> */}


                    {item.articles &&
                        <SalesArticleList 
                            articles={item.articles} 
                            // defaultSelected={lastChanged?.id}
                        />
                    }
                    
                </div>
            </div>
        );
    }

    if(props.noLink){
        return renderDetailItem();
    }

    let out = renderListItem();

    return (
        <div>
            <Link to={`/salesorder/${item.id}`}>
                {out}
            </Link>
        </div>
    )
};

export default SalesWrapListItem;
